var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dms-table',{attrs:{"table":_vm.dependentTables[_vm.SAGA_2_KOM],"name":_vm.SAGA_2_KOM,"label-key":"Saga2Komun","rows-on-page":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }